import { KTSVG, toAbsoluteUrl } from "../../../../_metronic/helpers";


/**
 * ConfirmPopup component displays a confirmation dialog for address selection.
 * Shows address details, allows edit or submit, and handles overlay/offcanvas UI.
 */
const ConfirmPopup = ({ show, setShow, item, onConfirm }) => {



    const handleClose = () => setShow(false);


    const offcanvasStyles = {
        position: 'fixed',
        bottom: show ? '0' : '-100%', // Sliding from bottom
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '500px', // Limit width on larger screens
        height: '370px',
        backgroundColor: '#fff',
        borderRadius: '15px 15px 0 0',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        transition: 'bottom 0.5s ease-in-out', // Slide up transition
        zIndex: 1050,
    };

    const overlayStyles = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        opacity: show ? 1 : 0,
        visibility: show ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease-in-out',
        zIndex: 1040,
    };

    return (
        <div className="App">
            {/* Overlay */}
            <div style={overlayStyles} onClick={handleClose}></div>

            {/* Custom Offcanvas */}
            <div style={{ ...offcanvasStyles, }}> {/* Add marginBottom here */}
                <div className="card rounded-5"  >
                    <div className="card-body">
                        <h1>Confirm Your Address</h1>
                        <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed p-2 mb-4">
                            <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger me-5' />

                            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                <div className=" mb-md-0 fw-semibold">

                                    <div className="fs-7 text-gray-700 pe-7">
                                        Please verify your address details below. These details cannot be edited further, so ensure they are correct for smooth delivery.
                                    </div>

                                </div>

                            </div>
                        </div>


                        <div className="col-sm-4 mb-4">
                            <div
                                style={{ border: (item.address_type === 'Home') ? '2px solid #828282' : '1px solid #E6E6E6', borderRadius: '15px', }}
                                className="card p-4 position-relative"
                            >
                                <div className="card-title m-0 d-flex align-items-center gap-4">
                                    <div
                                        className="symbol d-flex align-items-center justify-content-center position-relative"
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                            borderRadius: '50%',
                                            border: `2px solid ${Number(item?.status) === 1 ? '#28a745' : '#828282'}`, // Green for verified, gray otherwise
                                        }}
                                    >
                                        {item?.address_type?.toLowerCase() === 'home' ? (
                                            <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-home.png')} alt="redem-home" />
                                        ) : (item?.address_type?.toLowerCase() === 'other' ? (
                                            <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-other.png')} alt="redem-other" />) :
                                            <>
                                                <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-office.png')} alt="redem-office" />
                                            </>
                                        )}

                                        {/* Checkmark for verified addresses */}

                                        <i
                                            className="bi bi-check-circle-fill position-absolute"
                                            style={{
                                                fontSize: '13px',
                                                top: '-1px',
                                                right: '-1px',
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                color: Number(item?.status) === 1 ? '#28a745' : '#828282',
                                            }}
                                        ></i>

                                    </div>




                                    <button
                                        type="button"
                                        className="btn btn-link fs-3 fw-semibold text-black text-capitalize text-decoration-none"
                                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                        aria-label={`Address type: ${item?.address_type}`}
                                    >
                                        {item?.address_type}
                                    </button>
                                </div>
                                <div className="card-body p-2 ps-0 row">
                                    <div className="col-10">
                                        <p className="fs-6 ms-2 m-0 mt-2">
                                            {item?.address1 && `${item.address1},`}
                                            {item?.address2 && `${item.address2}`}
                                            {(item?.address1 || item.address2) && <br />}
                                            {item?.address3 && `${item.address3}, `}
                                            {item?.landmark && `${item.landmark}`}
                                            {(item?.address3 || item.landmark) && <br />}
                                            {item?.city && `${item.city}, `}
                                            {item?.district && `${item.district}, `}
                                            {item?.state && `${item.state}, `}
                                            {item?.pincode && `${item.pincode}`}
                                        </p>
                                    </div>

                                </div>
                                {item.address_type === 'Home' && (
                                    <div style={{
                                        borderBottomLeftRadius: '20px',
                                        backgroundColor: "#828282",
                                        borderTopRightRadius: '10px'
                                    }}
                                        className="position-absolute top-0 end-0 p-1 "
                                    >
                                        <span className="ms-4 text-white">Default Address</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="mt-4 d-flex gap-4">
                            <button onClick={handleClose} className="btn btn-sm btn-secondary w-100 py-4">Edit</button>
                            <button onClick={onConfirm} className="btn btn-sm btn-danger w-100 py-4">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};




export default ConfirmPopup;
